export default __webpack_public_path__ + "static/media/CMS_Company.18e4b361.svg";